import { render, staticRenderFns } from "./HydrologicalData.vue?vue&type=template&id=195622da&scoped=true"
import script from "./HydrologicalData.vue?vue&type=script&lang=js"
export * from "./HydrologicalData.vue?vue&type=script&lang=js"
import style0 from "./HydrologicalData.vue?vue&type=style&index=0&id=195622da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195622da",
  null
  
)

export default component.exports